var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAfterHoursButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.905,
    height: 13.861,
    viewBox: "0 0 14.905 13.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-out-svgrepo-com",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2640",
    "data-name": "Path 2640",
    d: "M8.06,15.861H4.687A1.574,1.574,0,0,1,3,14.432v-10A1.574,1.574,0,0,1,4.687,3H8.06",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#c400ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2641",
    "data-name": "Path 2641",
    d: "M16,13.114l3.414-3.057L16,7",
    transform: "translate(-5.509 -3.31)",
    fill: "none",
    stroke: "#c400ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_232",
    "data-name": "Line 232",
    x1: 7.78,
    transform: "translate(5.431 6.747)",
    fill: "none",
    stroke: "#c400ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterHoursButtonIcon);
export default __webpack_public_path__ + "static/media/after-hours-button-icon.1521ae3b0eae8ae7ecc69ffd8251af4a.svg";
export { ForwardRef as ReactComponent };